<template>
    <div id="app" v-if="$auth.ready()">
        <div v-if="$store.getters['loading']">
            <div class="full-page-loader">
                <div class="rubik-loader"></div>
            </div>
        </div>
        <div v-else-if="!$store.getters['loading']">
            <component :is="layout">
                <router-view />
            </component>
        </div>

        <portal-target name="modals" multiple></portal-target>
    </div>
</template>

<script>
    // Styles
    import Vue from 'vue'
    import '@/assets/sass/tailwind.scss'
    import '@/assets/sass/main.scss'

    import MainLayout from '@/views/Layouts/Main'
    import AuthLayout from '@/views/Layouts/Auth'

    import PortalVue from 'portal-vue'
    Vue.use(PortalVue)

    export default {
        components: {
            'layout-main': MainLayout,
            'layout-auth': AuthLayout
        },
        methods: {
            data: () => ({
                defaultLayout: 'layout-main'
            })
        },

        computed: {
            layout() {
                return `layout-${(typeof this.$route.meta !== 'undefined' && typeof this.$route.meta.layout !== 'undefined') ? this.$route.meta.layout : 'main'}`;
            }
        }
    }
</script>

<style lang="scss">
    #app {
        @apply .min-h-full .min-w-full;

        font-family: 'Raleway', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    }
    body {
        @apply .h-full .w-full .bg-purple;
    }
    .font-special {
        font-family: 'Coiny', 'Helvetica Neue', Helvetica, Arial, sans-serif;
    }
</style>
